module.exports = __webpack_public_path__ + "static/hitachi-59f2ac509df1e90044f4065f8b29a61b.jpg";